export var ActivationStatus;
(function (ActivationStatus) {
    ActivationStatus["ENABLED"] = "ENABLED";
    ActivationStatus["DISABLED"] = "DISABLED";
})(ActivationStatus || (ActivationStatus = {}));
export var VersionType;
(function (VersionType) {
    VersionType["BEST_VERSION"] = "BEST_VERSION";
    VersionType["LATEST_VERSION"] = "LATEST_VERSION";
    VersionType["DEV_VERSION"] = "DEV_VERSION";
})(VersionType || (VersionType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map